import GameModel from "../../GameModel";
import Upgrade from "./Upgrade";

export default class UpgradeCollection extends GameModel {
    constructor() {
        super();

        /**
         * @constant
         * @type {Upgrade[]}
         */
        this.upgrades = [];

        /**
         * Increments every time a change is made to the collection (add/remove).
         * @type {number}
         */
        this.changeCount = 0;
    }

    /**
     * @param {Upgrade} upgrade 
     */
    add(upgrade) {
        if (!upgrade) {
            console.log('UpgradeCollection.add() null upgrade');
            return;
        }
        this.upgrades.push(upgrade);
        this.changeCount++;
    }

    /**
     * Used for when adding lots of upgrades and we don't want to sort every single time.
     * @param {Upgrade} upgrade 
     */
    addBulk(upgrade) {
        if (!upgrade) {
            console.log('UpgradeCollection.addBulk() null upgrade');
            return;
        }
        this.upgrades.push(upgrade);
    }

    addBulkCompleted() {
        this.changeCount++;
    }

    /**
     * @param {Upgrade} upgrade 
     */
    remove(upgrade) {
        if (!upgrade) {
            console.log('UpgradeCollection.remove() upgrade null');
            return;
        }

        const index = this.upgrades.indexOf(upgrade);
        if (index === -1) {
            console.log('UpgradeCollection.remove() did not find upgrade in list');
            return;
        }

        this.upgrades.splice(index, 1);

        this.changeCount++;
    }

    ////////////////////////////////////
    // GameModel
    ////////////////////////////////////

    /**
     * @override
     */
    resetFull() {
        this.upgrades.length = 0;
        this.changeCount = 0;
    }

    /**
     * @override
     */
    resetForPrestige() {
        this.resetFull();
    }

}